import axios from "axios";
import { React, memo, useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "styled-components";
import RecipeStep from "./RecipeStep";
import RecipeStepLightbox from "./RecipeStepLightbox";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  color: ${({ theme }) => theme.colorOnSurface};
  background-color: ${({ theme }) => theme.colorSurface};
  border-radius: 8px;
  padding: 12px 0px;
  width: 400px;
  margin-bottom: 12px;
`;
const Head = styled.h3`
  padding-top: 0px;
  margin-top: 0px;
  padding: 0px 12px;
  flex: 1;
`;
const RecipeInstructions = memo(function ({ currentVideo, onSeek, onPause }) {
  const path = useLocation().pathname.split("/")[2];
  const [instructions, setInstructions] = useState([]);
  const [lightbox, setLightbox] = useState(null); // { stepIndex, imageIndex }
  const loadRecipeInstructions = useCallback(async () => {
    try {
      axios
        .get(
          `${process.env.REACT_APP_RECIPE_API_BASE_URL}/recipeSteps/${
            currentVideo?._id || path
          }`,
          {
            withCredentials: true,
          },
        )
        .then((instructionsRes) => {
          if (instructionsRes.status === 200) {
            setInstructions(instructionsRes.data);
          }
        });
    } catch (err) {
      console.log("Error fetching instructions: ", err);
    }
  }, [path, currentVideo]);
  useEffect(() => {
    loadRecipeInstructions();
  }, [path, loadRecipeInstructions]);
  const lightboxSteps = instructions.map((s) => ({
    ...s,
    images: s.imgURL,
  }));

  return (
    <Container>
      <Head>Instructions</Head>
      {instructions?.map((instruction, index) => (
        <RecipeStep
          key={instruction._id}
          title={instruction.title}
          time={instruction.time}
          desc={instruction.desc}
          images={instruction.imgURL}
          onSeek={onSeek}
          onExpand={(imgIndex = 0) => setLightbox({ stepIndex: index, imageIndex: imgIndex })}
        />
      ))}
      {lightbox !== null && (
        <RecipeStepLightbox
          steps={lightboxSteps}
          initialIndex={lightbox.stepIndex}
          initialImageIndex={lightbox.imageIndex}
          onClose={() => setLightbox(null)}
          currentVideo={currentVideo}
          onSeek={onSeek}
          onPause={onPause}
        />
      )}
    </Container>
  );
});
export default RecipeInstructions;
